<template>
  <div class="tw-p-2x">
    <div
      class="tw-h-full tw-w-full tw-p-4 tw-bg-white tw-rounded tw-border tw-border-b-2 tw-min-h-[calc(100dvh-185px)]">
      <div class="tw-justify-between tw-flex tw-items-center tw-h-[40px] tw-gap-2">
        <FormField v-model="search" input-dir="ltr" placeholder="ID, Name..." left-icon="clarity:search-line"
          type="text" class="tw-min-w-[100px]" />

          <div>
            <SetGoalPopup />
          </div>
      </div>
      <div class="tw-mt-5">
        <div :class="[selected.length ? 'tw-grid-rows-[1fr]' : 'tw-grid-rows-[0fr]']"
          class="tw-grid tw-duration-300 tw-transition-all">
          <div class="tw-overflow-hidden tw-col-span-1">

            <div class="tw-w-full tw-justify-between tw-mb-2 tw-rounded tw-bg-gray-50 tw-border tw-border-solid tw-border-gray-200 tw-flex tw-items-center tw-p-2">
              <div class="tw-flex tw-items-center tw-gap-2">
                <div class="tw-px-2 tw-bg-primary-500 tw-text-white tw-rounded-sm tw-font-semibold tw-text-sm">
                  {{ selected.length }}
                </div>
                <p class="tw-text-sm tw-font-medium">{{ $t('common.selected') }}</p>
              </div>
    
              <div>
                <button @click="onClearSelected" class="tw-px-4 tw-py-1 tw-bg-white tw-border tw-border-solid tw-border-gray-200 tw-text-sm tw-shadow-sm tw-rounded-sm tw-flex tw-items-center tw-gap-2 hover:tw-bg-gray-100/20 hover:tw-shadow-none tw-duration-200">
                  <icon icon="ic:round-close" class="tw-text-lg" />
                  <span>{{ $t('common.clear-selection') }}</span>
                </button>
              </div>
            </div>
            </div>

        </div>


        <UserTable :loading="loading" :items="users" :options="options" @next="onNext" @previous="onPrevious" />
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, provide } from 'vue'
import { byRoles } from '@/api/users';
import FormField from "@/components/form/FormField";
import UserTable from '@/views/admin/users/marketers/partials/table/UserTable';
import { all } from '@/api/roles';
import { useRoleStore } from '@/stores';
import SetGoalPopup from './partials/SetGoalPopup.vue';


const roleStore = useRoleStore();
const search = ref('')
const loading = ref(true)
const users = ref([]);
const options = ref({});
const selected = ref([]);

async function fetchUsers(page = 1) {
  loading.value = true;
  users.value = [];
  await byRoles(['marketer'],{ per_page: 10, page })
    .then(
      ({ data }) => {
        const { data: items, ...ops } = data.data;
        options.value = ops
        users.value = items;
      },
      error => {
        console.log(error)
      }
    )
  loading.value = false
}

async function fetchRoles() {
  loading.value = true;
  await all()
    .then(
      ({ data }) => {
        const roles = data.roles;
        roleStore.setRoles(roles);
        roleStore.setFetched(true)
      },
      error => {
        console.log(error)
      }
    )
  loading.value = false
}

const onNext = () => {
  fetchUsers(options.value.current_page + 1)
}

const onPrevious = () => {
  fetchUsers(options.value.current_page - 1)
}

const onCreated = (user) => {
  users.value.unshift(user)
}

const onUpdated = (user) => {
  users.value = users.value.map(u => u.id == user.id ? user : u)
}

const onDeleted = (id) => {
  users.value = users.value.filter(u => u.id != id)
}

const onClearSelected = () => {
  selected.value = [];
}

provide('onCreated', onCreated)
provide('onUpdated', onUpdated)
provide('onDeleted', onDeleted)
provide('selected', selected)

fetchUsers()
if(!roleStore.fetched) {
  fetchRoles()
}
</script>

<style></style>